import { useMemo } from 'react';

import { t } from '@lingui/macro';

import { createGlobalStyle } from 'styled-components';

import Wizard from '@decisiv/ui-components/lib/components/Wizard';
import StepOne from './StepOne';

import { useBulkAddAssetContext } from './context/BulkAddAssetContext';
import StepTwo from './StepTwo';
import StepThree from './StepThree';

const WIZARD_ID = 'bulk-add-asset-wizard';

const HidePhantomStep = createGlobalStyle`
  #${WIZARD_ID} [class*="StepTrackerContainer"] > [class*="StepWrapper"]:last-child {
    display: none;
  }
  #${WIZARD_ID}
    [class*="StepTrackerContainer"]
    > [class*="StepWrapper"]:nth-last-child(2)
    [class*="StepSeparator"]:last-child {
    visibility: hidden;
  }
`;

export default function BulkAddAssetModal() {
  const { stepOneProps, wizardProps } = useBulkAddAssetContext();

  const steps = useMemo(
    () => [
      {
        title: t`Upload`,
        content: <StepOne />,
        hideBodyTitle: true,
        ...stepOneProps,
      },
      {
        title: t`Summary`,
        content: <StepTwo />,
        hideBodyTitle: true,
      },
      {
        title: t`Summary`,
        content: <StepThree />,
        hideBodyTitle: true,
      },
    ],
    [stepOneProps],
  );

  return (
    <>
      <HidePhantomStep />
      <Wizard
        visible
        id={WIZARD_ID}
        title={t`Bulk Add Asset`}
        steps={steps}
        {...wizardProps}
      />
    </>
  );
}
